import { Spacing } from '@genial/design-tokens';
import React from 'react';

import {
  TableContent,
  TableContentItemColumn,
  TableContentItemText,
} from '../../../../../../components/TableContent';
import { getFlex } from '../../utils';

import { CancelButton } from './components/CancelButton';
import { StatusIcon } from './components/StatusIcon';
import { WithdrawalItemTypes } from './types';

export const WithdrawalItemDesktop: React.FC<WithdrawalItemTypes.Props> = ({ item, onCancel }) => {
  // const handleDownloadReceipt = () => {
  //   onDownloadReceipt(item.transactionIdNormalized, item.accountId);
  // };

  const handleCancel = () => {
    onCancel(item.transactionIdNormalized, item.accountId);
  };

  return (
    <TableContent
      direction="row"
      space={0}
      py={Spacing['stack.xxs']}
      px={Spacing['inline.xxxs']}
      spaceX={Spacing['inline.xxxs']}>
      <TableContentItemColumn flex={getFlex(0)}>
        <TableContentItemText>{item.transactionDateNormalized}</TableContentItemText>
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(1)}>
        <TableContentItemText>{item.scheduledDateNormalized}</TableContentItemText>
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(2)}>
        <TableContentItemText>{item.amountNormalized}</TableContentItemText>
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(3)}>
        <StatusIcon item={item} />
      </TableContentItemColumn>
      {/*<TableContentItemColumn flex={getFlex(4)}>*/}
      {/*  <DownloadButton onPress={handleDownloadReceipt} isDisabled={!item.haveReceipt} />*/}
      {/*</TableContentItemColumn>*/}
      <TableContentItemColumn flex={getFlex(5)}>
        <CancelButton onPress={handleCancel} isDisabled={!item.canCancel} />
      </TableContentItemColumn>
    </TableContent>
  );
};
